import type { ReactNode } from 'react';

import { TableCell, TableRow } from '../../ui/table';
import { cn } from '../../ui/utils';

const TONE_CLASS: Record<'active' | 'neutral', string> = {
  active: 'bg-primary-quiet',
  neutral: 'bg-muted',
};

/** A grouped `DataTable`'s section header: one `<tr>` with a single spanning
 *  cell, so the table stays one table and a screen reader still reads it as
 *  one, rather than several. */
export function GroupHeader(props: {
  colSpan: number;
  tone?: 'active' | 'neutral';
  children: ReactNode;
}): ReactNode {
  const { colSpan, tone = 'neutral', children } = props;
  return (
    <TableRow className={cn('hover:bg-transparent', TONE_CLASS[tone])}>
      <TableCell colSpan={colSpan} className="text-caption-sm font-medium text-foreground">
        {children}
      </TableCell>
    </TableRow>
  );
}
